import { CopyMessageButton } from "./CopyMessageButton";
import { DownloadRefsButton } from "./DownloadRefsButton";
import { FeedbackButtons } from "./FeedbackButtons";
import { ForkSessionButton } from "./ForkSessionButton";
import { SaveSessionButton } from "./SaveSessionButton";

interface Props {
  content: string;
}

export const MessageActionsBar = ({ content }: Props) => (
  <div className="mt-3 flex justify-start gap-1">
    <ForkSessionButton />
    <CopyMessageButton content={content} />
    <DownloadRefsButton />
    <SaveSessionButton />
    <FeedbackButtons />
  </div>
);
